import React from 'react';
import { Box, Typography } from '@mui/material';

interface EstimatedScheduleProps {
  scheduled: boolean;
  schedules?: { start: string; end: string }[];
}

const EstimatedSchedule: React.FC<EstimatedScheduleProps> = ({
  scheduled,
  schedules,
}) => {
  if (!scheduled || !schedules || schedules.length === 0) return null;

  return (
    <Box sx={{ paddingBottom: 1, width: '100%' }}>
      <Typography variant="subtitle2" gutterBottom>
        Estimated Schedule
      </Typography>
      <Box
        component="table"
        sx={{
          width: '100%',
          fontSize: '0.95rem',
          background: 'transparent',
          borderCollapse: 'collapse',
        }}
      >
        <tbody>
          <tr>
            <td style={{ fontWeight: 500, width: '50px' }}>Start</td>
            <td>
              <Typography variant="body2">{schedules[0].start}</Typography>
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: 500 }}>End</td>
            <td>
              <Typography variant="body2">{schedules[0].end}</Typography>
            </td>
          </tr>
        </tbody>
      </Box>
    </Box>
  );
};

export default EstimatedSchedule;
